import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    heightPercentageToDP,
    widthPercentageToDP,
} from 'utils/responsiveness';

import { ImageSize } from 'components/NagraImage/types';

export const CHANNEL_HEIGHT = heightPercentageToDP(56);

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        alignItems: 'center',
        height: CHANNEL_HEIGHT,
        borderRadius: 6,
        marginBottom: 8,
    },
    channelContainer: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: '100%',
        minHeight: heightPercentageToDP(56),
        paddingLeft: widthPercentageToDP(16),
    },
    logo: { width: ImageSize.SETTINGS_LIST_CHANNEL_LOGO.width },
    icon: {
        paddingHorizontal: widthPercentageToDP(16),
        paddingVertical: widthPercentageToDP(16),
    },
});

export default styles;
